<template>
    <div class="video-player" ref="videoPlayer">
        
        <video-loader
            ref="videoLoader"
            v-if="srcData"
            :data="srcData"
            :autoplay="autoplay"
            :loop="loop"
            @loaded="onVideoLoaded" 
            @progress="onVideoProgress"
            :style="{width: width+'px', height: height+'px', marginLeft: marginLeft+'px', marginTop: marginTop+'px'}"
        />
        
        <!-- TODO - Turn controls into slots that can be replaced -->
        <!-- https://codepen.io/chriscoyier/pen/MZzpoX -->
        <div class="controls" v-if="controls">
            <div class="playback" @click="togglePlayback">
                <div class="play" v-if="!isPlaying">
                    <svg id="play" width="18" height="18"><path d="M15.562 8.1L3.87.225c-.818-.562-1.87 0-1.87.9v15.75c0 .9 1.052 1.462 1.87.9L15.563 9.9c.584-.45.584-1.35 0-1.8z"></path></svg>
                </div>
                <div class="pause" v-if="isPlaying">
                    <svg id="pause" width="18" height="18"><path d="M6 1H3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1zm6 0c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h3c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1h-3z"></path></svg>
                </div>
            </div>
            
            <!-- Scrubb video -->
            <div class="progress-bar">
                <div class="total-progress" @click="onSeek" ref="totalProgress"></div>
                <div class="current-progress" ref="currentProgress"></div>
            </div>
            
            <!-- Mute / Unmute -->
            <div class="volume" @click="toggleVolume">
                <div class="muted" v-if="isMuted">
                    <svg id="muted" width="18" height="18"><path d="M12.4 12.5l2.1-2.1 2.1 2.1 1.4-1.4L15.9 9 18 6.9l-1.4-1.4-2.1 2.1-2.1-2.1L11 6.9 13.1 9 11 11.1zM3.786 6.008H.714C.286 6.008 0 6.31 0 6.76v4.512c0 .452.286.752.714.752h3.072l4.071 3.858c.5.3 1.143 0 1.143-.602V2.752c0-.601-.643-.977-1.143-.601L3.786 6.008z"></path></svg>
                </div>
                <div class="unmute" v-if="!isMuted">
                    <svg id="unmute" width="18" height="18">
                        <path d="M15.6 3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4C15.4 5.9 16 7.4 16 9c0 1.6-.6 3.1-1.8 4.3-.4.4-.4 1 0 1.4.2.2.5.3.7.3.3 0 .5-.1.7-.3C17.1 13.2 18 11.2 18 9s-.9-4.2-2.4-5.7z"></path>
                        <path d="M11.282 5.282a.909.909 0 0 0 0 1.316c.735.735.995 1.458.995 2.402 0 .936-.425 1.917-.995 2.487a.909.909 0 0 0 0 1.316c.145.145.636.262 1.018.156a.725.725 0 0 0 .298-.156C13.773 11.733 14.13 10.16 14.13 9c0-.17-.002-.34-.011-.51-.053-.992-.319-2.005-1.522-3.208a.909.909 0 0 0-1.316 0zm-7.496.726H.714C.286 6.008 0 6.31 0 6.76v4.512c0 .452.286.752.714.752h3.072l4.071 3.858c.5.3 1.143 0 1.143-.602V2.752c0-.601-.643-.977-1.143-.601L3.786 6.008z"></path>
                    </svg>
                </div>
            </div>
            

            <div class="fullscreen" @click="toggleFullscreen">
                <div class="enter-fullscreen" v-if="!isFullscreen">
                    <svg id="enter-fullscreen" width="18" height="18"><path d="M10 3h3.6l-4 4L11 8.4l4-4V8h2V1h-7zM7 9.6l-4 4V10H1v7h7v-2H4.4l4-4z"></path></svg>
                </div>
                <div class="exit-fullscreen" v-if="isFullscreen" >
                    <svg id="exit-fullscreen" width="18" height="18"><path d="M1 12h3.6l-4 4L2 17.4l4-4V17h2v-7H1zM16 .6l-4 4V1h-2v7h7V6h-3.6l4-4z"></path></svg>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
import VideoLoader from '@/components/VideoLoader'
import Size from '@/plugins/WindowSize'

export default {
    components: {
        VideoLoader
    },
    
    props: {
        data: {
            // EXAMPLE data - Array with src, widht & height
            // [
            //     {
            //         "url": "video-768x432.mp4",
            //         "width": 768,
            //         "height": 432
            //     },
            //     {
            //         "url": "video-1080x608.mp4",
            //         "width": 1080,
            //         "height": 608
            //     },
            //     {
            //         "url": "video-1920x1080.mp4",
            //         "width": 1920,
            //         "height": 1080
            //     }
            // ]
            type: Array,
            required: true
        },
        controls: {
            type: Boolean,
            default: false,
        },
        autoplay: {
            type: Boolean,
            default: false,
        },
        preload: {
            type: Boolean,
            default: false,
        },
        loop: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            // Variables
            srcData: '',
            videoAspect: null,
            marginLeft: 0,
            marginTop: 0,
            width: 0,
            height: 0,
            loaded: false,
            
            // Controls
            isPlaying: false,
            isMuted: false,
            isFullscreen: false,
        }
    },
    
    created() {
        Size.addListener(this.onResize)
    },
    
    destroyed() {
        Size.removeListener(this.onResize)
    },
    
    mounted() {
        
        if (this.preload === true) {
            this.load()
        }
        this.videoAspect = this.data[0].width / this.data[0].height
        
    },

    destroy() {

    },

    methods: {
        
        load() {
            this.srcData = this.data
            // this.srcData = [{
            //     url: this.url,
            //     width: this.width,
            //     height: this.height
            // }]
        },
        
        onVideoLoaded() {
            this.videoElement = this.$refs.videoLoader.$refs.video
            this.setVideoSize()
            this.loaded = true
            this.$emit('loaded')
        },
        
        togglePlayback() {
            if (this.isPlaying) {
                this.pause()
            } else {
                this.play()
            }
        },
        play() {
            if (!this.loaded) return
            this.videoElement.play()
            this.isPlaying = true
        },
        pause() {
            if (!this.loaded) return
            this.videoElement.pause()
            this.isPlaying = false
        },
        stop() {
            if (!this.loaded) return
            this.videoElement.currentTime = 0 // seek to beginning
            this.videoElement.pause()
        },
        // isLoaded() {
        //     return this.loaded
        // },
        
        onSeek(event) {
            
            var distance = event.offsetX
            var percentage = distance / this.$refs.totalProgress.offsetWidth
            var value = this.videoElement.duration * percentage
            this.videoElement.currentTime = value
            this.$refs.currentProgress.style.width = distance+'px'
        },
        
        onVideoProgress() {
            if (this.controls === false || this.videoElement.duration === isNaN) return
            
            var percent = this.videoElement.currentTime / this.videoElement.duration
            var width = percent * this.$refs.totalProgress.offsetWidth
            this.$refs.currentProgress.style.width = width+'px'
        },
        
        toggleVolume() {
            if (this.isMuted) {
                this.unmute()
            } else {
                this.mute()
            }
        },
        mute() {
            this.videoElement.volume = 0
            this.isMuted = true
        },
        unmute() {
            this.videoElement.volume = 1
            this.isMuted = false
        },
        
        toggleFullscreen() {
            if (!document.fullscreenElement) {
                this.$refs.videoPlayer.requestFullscreen().catch(err => {
                    throw new Error('Full-screen Failed: ', err.message, err.name);
                })
            } else {
                document.exitFullscreen()
            }
        },
        
        onResize() {
            this.setVideoSize()
        },
        
        setVideoSize() {
            
            var containerWidth = window.innerWidth //this.$refs.videoContainer.offsetWidth
            var containerHeight = window.innerHeight //this.$refs.videoContainer.offsetHeight
            var containerAspect = containerWidth / containerHeight
            
            // Landscape (wider)
            if (containerAspect >= this.videoAspect) {
                this.width = containerWidth
                this.height = Math.round(containerWidth/this.videoAspect) // 1920/(16/9) = 1080
                this.marginTop = (containerHeight/2) - (this.height/2) // height/2 - window.height/2;
                this.marginLeft = 0
                
            }
            // Portrait (taller)
            else if (containerAspect < this.videoAspect) {
                this.marginLeft = -Math.round(((containerHeight*this.videoAspect) - containerWidth) / 2)
                this.marginTop = 0
                this.width = Math.round(this.videoAspect*containerHeight) // (16/9)*1080 = 1920
                this.height = containerHeight
            }
            
        },
        

    },
    
    computed: {
        isLoaded() {
            return this.loaded
        },
    }
}
</script>


<style lang="scss" scoped>

.video-player {
    position: absolute;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    width: 100%;
    height: 100vh;
    background-color: #000;

    video {
        width: 100%;
        
        // https://css-tricks.com/custom-controls-in-html5-video-full-screen/
        &::-webkit-media-controls {
            display:none !important;
        }
    }
    
    .controls {
        position: absolute;
        bottom: 20px;
        height: 40px;
        width: 50%;
        left: 0;
        right: 0;
        margin: 0 auto;
        background: #000;
        padding: 10px;
        
        .playback,
        .progress-bar,
        .volume,
        .fullscreen {
            display: inline-block;
            vertical-align: top;
            margin-right: 20px;
            
            &:last-child {
                margin-right: 0;
            }
            svg {
                fill: #fff;
            }
        }
        
        .playback {
            cursor: pointer;
            .play {
                
            }
            .pause {
                
            }
        }
        .progress-bar {
            width: calc(100% - 128px);
            position: relative;
            margin-top: 5px;
            
            .total-progress {
               width: 100%;
               height: 10px;
               background: #fff;
               cursor: pointer;
           }
           .current-progress {
               position: absolute;
               top: 0;
               width: 0;
               height: 10px;
               background: rgba(0, 0, 0, 0.3);
               pointer-events: none;
               transition: 0.25s width linear;
           }
        }
        .volume {
            cursor: pointer;
            .muted {}
            .unmute {}
        }
        .fullscreen {
            cursor: pointer;
            // width: 40px;
        }
        
    }
}
</style>
